<template>
  <USelectMenu
    v-model="modelValue"
    :items="directionItems"
    :class="ui?.root"
    class="select-menu pl-5 pr-3 max-w-43.5 min-w-43.5 max-lg:min-w-12! shrink grow-0 text-neutral-default font-medium text-size-normal!"
    label-key="name"
    multiple
    leading-icon="i-local-settings"
    :search-input="{
      icon: 'i-local-search',
      loadingIcon: 'w-4 h-4',
      placeholder: 'Поиск',
    }"
    :ui="{
      leadingIcon: 'lg:hidden max-lg:px-3.5',
      trailingIcon:
        'group-data-[state=open]:rotate-180 transition-transform duration-200 text-neutral-default w-6 h-6 max-lg:hidden',
      itemTrailingIcon: 'hidden',
      content: 'w-80 max-lg:w-85',
    }"
  >
    <template #item-leading="{ item }">
      <UCheckbox
        :model-value="isDirectionSelected(item as DirectionMenuItem)"
        :ui="{
          root: 'pointer-events-none',
          base: 'w-5 h-5 ring-neutral-border-default ring-2 bg-background-bg1',
          icon: 'h-4 w-4',
        }"
      />
    </template>

    <template #content-bottom>
      <div class="border-t border-border-light text-right">
        <UButton variant="link" @click="modelValue = []">
          Очистить выбор
        </UButton>
      </div>
    </template>

    <span class="typo-paragraph-md-medium! text-neutral-default max-lg:hidden"
      >Направление</span
    >

    <!-- <div
        v-if="selectedDirections?.length"
        class="absolute -top-2.75 -right-2.75 w-6 h-6 flex justify-center items-center text-white bg-accent-default rounded-full border-2 text-size"
      >
        {{ selectedDirections.length }}
      </div> -->
  </USelectMenu>
</template>

<script lang="ts" setup>
import type { DirectionMenuItem } from '~/types'

const directoryStore = useDirectoryStore()
const { directions } = storeToRefs(directoryStore)

defineOptions({
  name: 'DirectionsDropdown',
})

defineProps<{
  ui?: {
    root?: string
  }
}>()

const modelValue = defineModel<DirectionMenuItem[]>({
  required: true,
})

const directionItems = computed(() => {
  return (directions?.value || [])?.map((direction) => ({
    ...direction,
    description: direction.description ?? undefined,
  })) as DirectionMenuItem[]
})

const isDirectionSelected = (item: DirectionMenuItem) => {
  return modelValue.value.some((d: DirectionMenuItem) => d?.id === item.id)
}
</script>

<style></style>
